import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useI18n } from "./i18n/I18nContext";
import "./Login.css";

export default function Login() {
  const { t } = useI18n();

  const [username, setUsername]       = useState("");
  const [password, setPassword]       = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError]             = useState("");
  const navigate = useNavigate();
  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    try {
      const res  = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || t("login.errorLogin")); return; }
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      navigate("/menu");
    } catch {
      setError(t("login.errorServer"));
    }
  }

  return (
    <div className="login-root">

      <div className="login-logo-wrap">
        <div className="login-logo-title">WOODOO</div>
        <div className="login-logo-sub">AUGMENTED WOOD</div>
        <hr className="login-divider" />
      </div>

      <form onSubmit={handleSubmit} className="login-form">
        <h1 className="login-title">{t("login.title")}</h1>

        {error && <div className="login-error">{error}</div>}

        <div className="login-field">
          <label className="login-label">{t("login.username")}</label>
          <input
            className="login-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
            autoComplete="username"
          />
        </div>

        <div className="login-field">
          <label className="login-label">{t("login.password")}</label>
          <div className="login-password-wrap">
            <input
              className="login-input login-input-password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              className="login-eye-btn"
              onClick={() => setShowPassword((v) => !v)}
              tabIndex={-1}
            >
              {showPassword
                ? <AiOutlineEyeInvisible size={20} />
                : <AiOutlineEye size={20} />}
            </button>
          </div>
        </div>

        <button type="submit" className="login-submit">
          {t("login.submit")}
        </button>
      </form>

    </div>
  );
}
